import { MonoTypeOperatorFunction } from 'rxjs';
import { tap } from 'rxjs/operators';

export const tapNextOrError = <T>(callback: () => void): MonoTypeOperatorFunction<T> => tap<T>({ next: () => callback(), error: () => callback() });
